// extracted by mini-css-extract-plugin
module.exports = {"timer":"_4569","item":"_21","divider":"_19479"};